exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__header___1uOTx{font-family:PlayfairDisplay-Regular;font-size:32px;font-weight:300;margin:0}.style__header___1uOTx.style__small___28tb8{position:absolute;top:-4px;font-size:18px;letter-spacing:1px;color:#333}.style__header___1uOTx sup{position:relative;top:8px}.style__headerDetails___2TIHR{font-family:PlayfairDisplay-Regular;font-style:italic;font-size:18px;margin:12px 0;text-align:left}.style__headerDetails___2TIHR.style__small___28tb8{font-family:Poppins-Light;font-size:14px;font-weight:300;line-height:2.1;letter-spacing:.6px;color:#333;font-style:normal;text-align:left;margin-top:16px;margin-bottom:2px}", ""]);

// exports
exports.locals = {
	"header": "style__header___1uOTx",
	"small": "style__small___28tb8",
	"headerDetails": "style__headerDetails___2TIHR"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/item-header/style.css
// module id = 690
// module chunks = 0